<main class="container" aria-label="paginaSobre">
  <section aria-label="expediente" id="expediente">
    <h1 class="title">Expediente</h1>
    <!-- <hr class="bg-color-grey" /> -->
    <hr class="bg-color-dark-grey hr-line" />
    <div class="content" [innerHTML]="sobre | format2 | higienizaHTML:'HTML'" #expediente></div>
  </section>
  <br />
  <!-- <section aria-label="legislacao" id="legislacao">
    <h1 class="title">Legislação</h1>
    <hr class="bg-color-grey" />
    <br />
    <p class="legislacao-text">Aguardando...</p>
  </section> -->
</main>